import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import moment from 'moment';

// Helpers
import { formatDate } from '../../helpers';

// Component
import DynamicTable from '../../components/DynamicTable';
// Images
import eye from '../../../sass/images/ver-ocultar.svg';
import calendarIcon from '../../../sass/images/icons/calendar-day.svg';

const dateFormatList = ['DD/MM/YYYY', 'DD-MM-YYYY'];

export default function TripsTable({ trips, loading, onSelect, titleTranslate }) {
    const [dateFrom, setDateFrom] = useState(null);
    const [dateTo, setDateTo] = useState(null);

    const filteredTrips = useMemo(() => {
        if (!dateFrom && !dateTo) return trips;
        return trips.filter((trip) => {
            const tripDate = moment(trip.begin_at);
            if (dateFrom && tripDate.isBefore(dateFrom, 'day')) return false;
            if (dateTo && tripDate.isAfter(dateTo, 'day')) return false;
            return true;
        });
    }, [trips, dateFrom, dateTo]);

    const columns = [
        { title: 'ID', dataIndex: 'flespi_trip_id', key: 'id' },
        { title: 'vehiclesTrips.start_date', dataIndex: 'begin_at', key: 'start', render: (value) => formatDate(value.begin_at) },
        { title: 'vehiclesTrips.end_date', dataIndex: 'end_at', key: 'end', render: (value) => formatDate(value.end_at) },
        { title: 'vehiclesTrips.distance', dataIndex: 'distance', key: 'distance' },
        { title: 'vehiclesTrips.avg_speed', dataIndex: 'avg_speed', key: 'avg_speed' },
        {
            title: 'vehiclesTrips.action',
            key: 'action',
            render: (trips) => (
                <button type="button" onClick={() => onSelect(trips)}>
                    <img src={eye} alt="Ver información" />
                </button>
            ),
        },
    ];

    return (
        <>
            <div className="convention-services flex">
                <div className="modal-display row-states">
                    <div className="block-datepicker">
                        <div className="input-filter">
                            <label htmlFor="dateFrom" className="col-form-label">
                                {titleTranslate('vehiclesTrips.date_from')}
                            </label>
                            <br />
                            <DatePicker
                                showToday
                                value={dateFrom}
                                format={dateFormatList}
                                suffixIcon={<img src={calendarIcon} alt={titleTranslate('alt:calendar')} />}
                                placeholder=""
                                onChange={setDateFrom}
                                disabledDate={(current) => dateTo ? current && current.isAfter(dateTo, 'day') : false}
                            />
                        </div>
                        <div className="input-filter">
                            <label htmlFor="dateTo" className="col-form-label">
                                {titleTranslate('vehiclesTrips.date_to')}
                            </label>
                            <br />
                            <DatePicker
                                showToday
                                value={dateTo}
                                format={dateFormatList}
                                suffixIcon={<img src={calendarIcon} alt={titleTranslate('alt:calendar')} />}
                                placeholder=""
                                onChange={setDateTo}
                                disabledDate={(current) => dateFrom ? current && current.isBefore(dateFrom, 'day') : false}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <DynamicTable
                data={filteredTrips}
                loading={loading}
                columns={columns}
                rowKey="id"
                titleTranslate={titleTranslate}
            />
        </>
    );
}


TripsTable.propTypes = {
    trips: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
};